import React from "react";

import { isJSXElement } from "@utils/common";

export interface ComparisonDataProps {
    featureName: string | JSX.Element;
    gallabox: string | JSX.Element;
    competitor: string | JSX.Element;
}

export interface HeaderDataProps {
    title: string | JSX.Element;
    isGallabox: boolean;
}

interface FeaturesComparisonTableProps {
    mainTitle?: string | JSX.Element;
    note?: string;
    headerData: HeaderDataProps[];
    comparisonData: ComparisonDataProps[];
}

const FeaturesComparison: React.FC<FeaturesComparisonTableProps> = (props) => {
    const { mainTitle, note, headerData, comparisonData } = props;
    return (
        <div className="lg:max-w-6xl lg:mx-auto w-fit mx-2 flex flex-col gap-10 items-center my-20">
            {mainTitle && <h2 className="text-3xl font-bold text-gray-700 text-center">{mainTitle}</h2>}
            <div className="lg:max-w-6xl max-w-sm lg:mx-auto mx-4 overflow-auto">
                <section className="grid grid-cols-3">
                    {headerData.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={`${
                                    item.isGallabox ? "text-white border border-solid border-white" : "bg-white text-gray-500 border border-solid border-gray-300"
                                }  lg:px-20 lg:py-7 px-2.5 py-5  flex items-center justify-center ${index === 0 ? "rounded-tl-lg" : index === 2 ? "rounded-tr-lg" : ""}`}
                                style={item.isGallabox ? { backgroundColor: "#2b6cb0" } : {}}
                            >
                                {isJSXElement(item.title) ? item.title : <h6 className="lg:text-2xl text-xl font-medium text-gray-700">{item.title}</h6>}
                            </div>
                        );
                    })}
                    {comparisonData.map((contentlist, index) => {
                        const itemStyle = "lg:p-4 py-2 px-1 text-center flex items-center justify-center border-b border-l border-r border-solid";
                        return (
                            <React.Fragment key={index}>
                                <p className={`${index === comparisonData.length - 1 ? "rounded-bl-lg" : ""} bg-white text-gray-500 ${itemStyle} border-gray-300`}>
                                    {contentlist.featureName}
                                </p>
                                <p style={{ backgroundColor: "#2b6cb0" }} className={`text-white ${itemStyle} border-white`}>
                                    {contentlist.gallabox}
                                </p>
                                <p className={`${index === comparisonData.length - 1 ? "rounded-br-lg" : ""} bg-white text-gray-500 ${itemStyle} border-gray-300`}>
                                    {contentlist.competitor}
                                </p>
                            </React.Fragment>
                        );
                    })}
                </section>
            </div>
            {note && <p className="mx-2 text-base font-medium text-blue-500 text-center">{note}</p>}
        </div>
    );
};

export default FeaturesComparison;
